<script setup lang="ts">
import ILxcSettings from "~icons/lxc/settings";

const { t } = useI18n();

const props = defineProps<{
  entityName: string;
  deviceCount: number;
}>();

const emit = defineEmits(["click:settings"]);

const deviceCountLabel = computed(() => {
  return props.deviceCount >= 0
    ? t("administration.businessUnit.list.deviceCount", props.deviceCount)
    : "";
});

function onSettingsClick(event: Event) {
  event.preventDefault();
  event.stopPropagation();
  emit("click:settings");
}
</script>

<template>
  <div class="flex items-center">
    <h5 class="w-1/2 my-0">{{ entityName }}</h5>
    <div
      class="w-1/2 self-center text-[#9C9C9C] text-xs font-semibold overflow-hidden text-ellipsis text-nowrap flex items-center justify-center"
      :title="deviceCountLabel"
    >
      <span :class="{ invisible: deviceCount < 0 }">{{
        deviceCountLabel
      }}</span>
      <lxc-button
        html-type="button"
        type="borderless"
        :icon="ILxcSettings"
        :title="t('administration.businessUnit.settings.button')"
        class="invisible group-hover:visible !px-0 !py-0 ml-4"
        icon-class="!w-6 h-6"
        @click="onSettingsClick"
      />
    </div>
  </div>
</template>
